import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/workspace/OPAM-project/frontend-next/node_modules/next/dist/client/app-dir/link.js");
